import React from 'react';
import './ui.css';

export type SurfaceVariant = 'nav' | 'content' | 'inspector';

export interface SurfaceProps {
  variant: SurfaceVariant;
  children?: React.ReactNode;
  id?: string;
  role?: string;
  'aria-label'?: string;
}

const Surface = React.forwardRef<HTMLDivElement, SurfaceProps>(
  ({ variant, children, id, role, ...aria }, ref) => (
    <div
      ref={ref}
      id={id}
      role={role}
      aria-label={aria['aria-label']}
      className={`ui-surface ui-surface--${variant}`}
    >
      {children}
    </div>
  ),
);
Surface.displayName = 'Surface';

export default Surface;
